/*
 *  Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 *  All information herein, source code below as well as the Morpheus system itself and all related
 *  software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 *  Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 *  is prohibited.
 */

import _Vue from 'vue'
import { attachAccessTokenToHeaders, autoLogoutUser } from '@/services/axios/interceptors'
import { Store } from 'vuex'
import { RootState } from '@/store/types'

import { authClient } from '@morpheus/admin/admin-vue/services/auth-client'
import { adminClient } from '@morpheus/admin/admin-vue/services/admin-client'
import { configClient } from '@morpheus/config/admin-vue/services/config-client'
import { versionsClient } from '@morpheus/versioning/admin-vue/services/versions-client'
import { loggerClient } from '@morpheus/logger/admin-vue/services/logger-client'
import { usersClient } from '@morpheus/user/admin-vue/services/users-client'
import { inventoryClient } from '@morpheus/inventory/admin-vue//services/inventory-client'
import { productsClient } from '@morpheus/product/admin-vue/services/products-client'
import { procodesClient } from '@morpheus/procodes/admin-vue/services/procodes-client'
import { rootClient } from '@morpheus/utils/admin-vue/services/root-client'
import { printableCodesClient } from '@morpheus/printable-codes/admin-vue/services/printable-codes-client'
import { currenciesClient } from '@morpheus/currency/admin-vue/services/currencies-client'
import { shopsClient } from '@morpheus/shop/admin-vue/services/shops-client'
import { scriptClient } from '@morpheus/script/admin-vue/services/script-client'
import { statsClient } from '@morpheus/stats/admin-vue/services/stats-client'

export interface AxiosPluginOptions {
  store: Store<RootState>;
}

const appInstances = [
  authClient,
  adminClient,
  configClient,
  versionsClient,
  loggerClient,
  usersClient,
  inventoryClient,
  productsClient,
  procodesClient,
  rootClient,
  printableCodesClient,
  currenciesClient,
  shopsClient,
  scriptClient,
  statsClient
]

export const AxiosPlugin = function AxiosPlugin (Vue: typeof _Vue, options: AxiosPluginOptions): void {
  appInstances.forEach((instance) => {
    attachAccessTokenToHeaders(instance, options.store)
    autoLogoutUser(instance, options.store)
  })
}
